var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaKit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 9,
    fill: "#F5DC7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0704 17.8388C8.2641 17.8388 6.7998 16.3781 6.7998 14.5764C6.7998 12.7746 8.2641 11.3139 10.0704 11.3139H11.1494M10.0704 17.8388C10.0704 17.8388 11.1998 21.7515 11.5998 22.9474C11.9998 24.1432 13.9998 24.1432 13.9998 22.5488C13.9998 20.9543 13.9998 20.079 13.9998 18.0468M10.0704 17.8388H11.1494M13.9998 18.0468C16.278 18.5658 18.3892 19.9487 20.4204 20.9619C24.4909 22.992 24.3996 16.5535 24.3996 14.5763C24.3996 12.5992 24.4909 6.16071 20.4204 8.19085C17.8727 9.46153 15.1993 11.3139 12.2284 11.3139H11.1494M13.9998 18.0468C13.4206 17.9149 12.8306 17.8388 12.2284 17.8388H11.1494M11.1494 17.8388V11.3139",
    stroke: "#2D264B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2002 12.5996V16.5996",
    stroke: "#2D264B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaKit2);
export default __webpack_public_path__ + "static/media/media-kit-2.2c83a1d1e5683e98e45f0a670410f270.svg";
export { ForwardRef as ReactComponent };